// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__xdkBH","controls":"styles_controls__1Y6sa","charLimit":"styles_charLimit__3cxRF","input":"styles_input__1UWWd","send":"styles_send__ZixV0"};